export type Result = {
    id: string
    locale: string
    pageUrl: string
    shortDescription: string
    title: string
}

export const toggleDropdown =
    ({ query, results, setOpen }: { query: string; results: Result[]; setOpen: (open: boolean) => void }) =>
    (): void => {
        if (query) {
            setOpen(Boolean(results.length))
        }
    }

export const closeDropdown = (setOpen: (open: boolean) => void) => (): void => {
    setOpen(false)
}

export const onChange =
    (setQuery: (query: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>): void =>
        setQuery(e.target.value)
